<template lang="">
    <v-card>
        <v-container fluid tyle="margin: 0px; padding: 0px; width: 50%">
            <hmi-reguladores1></hmi-reguladores1>
            <hmi-reguladores2></hmi-reguladores2>
        </v-container>
        
    </v-card>
</template>
<script>
    import HmiReguladores1 from "@/components/HMI/HmiReguladores1.vue";
    import HmiReguladores2 from "@/components/HMI/HmiReguladores2.vue";
export default {
    components:{
        HmiReguladores1,HmiReguladores2
    },
    
    
}
</script>
<style lang="">
    
</style>